import { graphqlClient } from "@/core/api/graphql/client";
import assetOperationMutation from "./assetOperations.graphql";
import type {
  Mutations,
  AssetOperationResultType,
  InputAssetOperationActionType,
  MutationsAssetOperationsArgs,
} from "@/core/api/graphql/types";

export async function assetOperations(
  payload: InputAssetOperationActionType[],
): Promise<AssetOperationResultType | undefined> {
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "assetOperations">>,
    MutationsAssetOperationsArgs
  >({
    mutation: assetOperationMutation,
    variables: {
      command: {
        operations: payload,
      },
    },
  });

  return data?.assetOperations;
}
